import {BaseContainerModel} from '../../base-container.model';
import {bl_cms_theme_instance_hdr_RowClass} from '../../../dbschema';

export class ThemeInstanceHeaderContainerModel extends BaseContainerModel {

  bl_cms_theme_instance_hdr: bl_cms_theme_instance_hdr_RowClass = new bl_cms_theme_instance_hdr_RowClass();
}
